module.exports = __webpack_public_path__ + "img/btn-close-weak.bd44f67b.svg";